export default __webpack_public_path__ + "static/media/blog-34-image-1.2cd7c19d.jpg";